import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const SignupContainer = styled.div`
  padding: 40px;
  min-height: 468px;
  background: white;
  border-radius: 4px;

  > h4,
  > h6 {
    width: 100%;
    text-align: left;
  }

  > h6 {
    font-weight: normal;
    margin-top: 25px;
    margin-bottom: 0;
  }
  > img {
    margin: auto;
  }

  .radio-field-wrapper {
    height: 100%;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .radio-div {
      flex: 30%;
      max-width: 30%;
      margin: 0 15px 20px 0;
      label {
        padding: 15px;
      }
      &:last-child label {
        border-left: 1px solid var(--grey-4);
      }
    }

    &.radio-field-error {
      .radio-div {
        &:last-child label {
          border-left: 1px solid var(--critical-3);
        }
        &.selected label {
          border-left: 1px solid var(--titan-blue-6) !important;
        }
      }
    }
  }
  .input-failed-value {
    color: var(--critical-3);
    margin: auto;
  }

  .signup-modal--form-container {
    & > div {
      padding: 0;
    }

    .signup-form--footer,
    .signup-form--footer-1 {
      display: none;
    }

    .signup-modal--signup-link {
      font-size: var(--font-size-20);
      font-weight: var(--font-weight-500);
      text-align: center;
      margin-top: 30px;
    }
  }

  @media (max-width: 575px) {
    button {
      width: 100%;
    }
  }

  @media (min-width: 576px) {
    width: 520px;
  }
`;
